module.exports = __webpack_public_path__ + "static/img/Just Eat.f87c971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Just Eat.png
// module id = OciF
// module chunks = 4